<div layout="row" layout-align="end center">
  <button class="close" mat-icon-button (click)="onNoClick()">
    <mat-icon style="color: rgb(0, 0, 0)">clear</mat-icon>
  </button>
</div>
<div class="container">
  <div class="title_section">
    <div class="title el-font-popup-heading">
      {{ 'newsletter.title-1' | translate }}
      <span class="title-pink el-font-popup-heading">
        {{ 'newsletter.title-2' | translate }}</span
      >
    </div>

    <p class="sub_title el-font-thanks-popup-sub-heading">
      {{ 'newsletter.sub-title' | translate }}
    </p>
  </div>
  <mat-dialog-content class="dialog-content" [formGroup]="newsletterForm">
    <div class="row">
      <div class="col-12">
        <mat-label class="name_label"
          >{{ 'newsletter.email' | translate }}*</mat-label
        >
        <mat-form-field appearance="outline">
          <input
            type="email"
            formControlName="email"
            placeholder="john@company.com"
            matInput
            pattern="^([A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64})|([0-9]{10})$"
            required
            (input)="onEmailInput($event)"
          />
          <mat-error
            *ngIf="newsletterForm.controls.email.hasError('required')"
            >{{ 'newsletter.email-required' | translate }}</mat-error
          >
          <mat-error *ngIf="newsletterForm.controls.email.hasError('email')">
            <p>
              {{ 'newsletter.email-invalid' | translate }}
            </p>
          </mat-error>
          <mat-error
            *ngIf="newsletterForm.controls.email.hasError('duplicate')"
          >
            <p>
              {{ 'newsletter.email-duplicate' | translate }}
            </p>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <div class="button">
    <div class="col-12 sub_button pl-0 pr-0">
      <el-button
        name="Subscribe"
        [isFilled]="true"
        [isFocusEnabled]="false"
        (click)="onSubmit()"
        [disabled]="newsletterForm.invalid"
        innerClass="news-and-alert--submitBtn"
      ></el-button>
    </div>
  </div>
</div>
